import React from 'react';
import classnames from 'classnames';
import ModalContainer from './ModalContainer';
class CustomModal extends React.Component {
    constructor(props) {
        super(props);
        this.transitionShowModal = () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: true,
                    willHidden: false,
                });
            }, 400);
        };
        this.transitionHiddenModal = () => {
            this.setState({
                willHidden: true,
            });
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.setState({
                    show: false,
                    willHidden: false,
                });
            }, 400);
        };
        this.wrapClick = () => {
            if (this.props.maskClick) {
                this.props.maskClick();
            }
        };
        this.contentClick = (e) => {
            e.stopPropagation();
        };
        this.state = {
            show: props.visible,
            willHidden: false,
        };
    }
    componentDidUpdate(preProps) {
        if (preProps.visible && !this.props.visible) {
            // 隐藏
            this.transitionHiddenModal();
        }
        else if (!preProps.visible && this.props.visible) {
            // 显示
            this.transitionShowModal();
        }
    }
    render() {
        const { visible, className, children, preMunt, animateIn, animateOut, translateX = 0, translateY = 0 } = this.props;
        const { show, willHidden } = this.state;
        if (!visible && !preMunt && !show) {
            return null;
        }
        return (<ModalContainer visible={show || visible} className={className}>
        <div className='cfm_modal_mask'/>
        <div className={classnames('cfm_modal_wrap')} onClick={this.wrapClick} style={{ 'transform': `translate(${translateX}px, ${translateY}px)` }}>
          <div className={classnames('cfm_cus_modal_content', animateIn && `cfm_confirm_${animateIn}_will_show`, animateOut && willHidden && `cfm_confirm_${animateOut}_will_hidden`)} onClick={(e) => this.contentClick(e)}>
            {children}
          </div>
        </div>
      </ModalContainer>);
    }
}
CustomModal.ModalContainer = ModalContainer;
CustomModal.defaultProps = {
    preMunt: false,
};
export default CustomModal;



// WEBPACK FOOTER //
// ./components/modal/Custom.tsx